import { TaxpayerDetails } from '../../types'
import { AccountType } from '../../types/taxpayerDetails'

export const taxpayerDetailsFixture = ({
  accountType = AccountType.consumer,
  companyName,
  taxId,
  nonProfitTaxId,
  lockedFields,
  pecEmailOrRecipientCode
}: TaxpayerDetails = {}): TaxpayerDetails => ({
  accountType,
  lockedFields,
  companyName,
  taxId,
  nonProfitTaxId,
  pecEmailOrRecipientCode
})
